import('scss/app.scss');

require('user_dashboard')

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()